import { VERIFICATION_STATUSES } from '../../constants/verificationStatuses'

const VerificationStatusMessage = ({ status }) => {
  const getStatusConfig = (status) => {
    return VERIFICATION_STATUSES[status] || VERIFICATION_STATUSES.draft
  }

  const statusConfig = getStatusConfig(status)

  return (
    <div className={`p-4 rounded-lg border ${statusConfig.color} border-current border-opacity-20`}>
      <div className="flex items-center gap-2 mb-2">
        <h4
          className={`inline-flex items-center  rounded-full text-lg font-medium ${statusConfig.color}`}
        >
          {statusConfig.label}
        </h4>
      </div>
      <p className="text-sm leading-relaxed">{statusConfig.message}</p>
    </div>
  )
}

export default VerificationStatusMessage
